import testhermeticidad1 from '../testhermeticidad/testhermeticidad1.png'

const testhermeticidadImagenes = [
    testhermeticidad1,
]

export default testhermeticidadImagenes